/**
 * Copyright 2026 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { ReactNode } from "react";
import { EventActionType, PlanActionType } from "~/generated/graphql";
import { getDisplayNameByActionType } from "~/views/plans/utils";

type Props = {
  actionName: string;
  customName: string;
  actionType: PlanActionType | EventActionType | undefined;
  isActionBatch?: boolean;
  renderEditableName?: (name: string) => ReactNode;
};

export function ActionNameDisplay({
  actionName,
  customName,
  actionType,
  isActionBatch = false,
  renderEditableName,
}: Props) {
  const formattedActionName = isActionBatch
    ? actionName
    : getDisplayNameByActionType(actionName, actionType);

  const hasCustomName =
    !!customName?.trim() &&
    customName.trim() !== actionName.trim() &&
    customName.trim() !== formattedActionName.trim();

  // If there is a custom name, display custom name first, then the formatted action name below
  if (hasCustomName) {
    return (
      <>
        {renderEditableName ? renderEditableName(customName ?? "") : customName}
        <div
          style={{
            opacity: 0.6,
            fontSize: "0.85rem",
          }}
        >
          {formattedActionName}
        </div>
      </>
    );
  }

  return (
    <>
      {renderEditableName
        ? renderEditableName(formattedActionName)
        : formattedActionName}
    </>
  );
}
